import { useContext } from 'react';
import { AppThemeContext } from '../contexts/AppThemeContext';

export function useTheme() {
  const context = useContext(AppThemeContext);
  if (!context) {
    throw new Error('useTheme must be used inside ThemeProvider');
  }

  return context;
}
